import { webViewerDediconPrintOpts } from './../core/common';
import { getDeviceName } from '../core/common';
import { ToastrDialogService } from './toastr-dialog.service';
import { ApiNamesEnum, ToastrActionEnum, ToastrStringsEnum } from '../utils/enums';
import { HuginnErrorCodesEnum } from '../utils/enums/error-codes';
import { ModalWindowService } from './ui/modal-window.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth/auth.service';
import { AccountService } from './auth/account.service';
import { Injectable, NgZone } from '@angular/core';
// import { CommonMessageDialogComponent } from '../components/dialogs/common-message-dialog/common-message-dialog.component';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import { ILoginResponseModel } from '../utils/interfaces';
import WebViewer, { Core, WebViewerInstance } from '@pdftron/webviewer';
import { KeyVaultSecretResponse, KeyVaultService } from './key-vault.service';
import { KeyVaultKeys } from '../utils/enums/key-vault-keys.enum';

declare var platform;



@Injectable({
  providedIn: 'root'
})
export class DediconPDFService {
  private dediconPdfUrl: string = environment.conversions.dediconPdfUrl;

  // private get internalWV(): HTMLIFrameElement | null {
  //   const wvElement = document.getElementById('webviewerInternal');
  //   return wvElement !== null ? wvElement.querySelector('iframe') as HTMLIFrameElement : null;
  // }

  // private get internalPDFNet(): any | null {
  //   return this.internalWV !== null ? (this.internalWV.contentWindow as any).PDFNet : null;
  // }

  constructor(
    private http: HttpClient,
    private accountService: AccountService,
    private toastrService: ToastrDialogService,
    private modalService: ModalWindowService,
    private authService: AuthService,
    private ngZone: NgZone,
    private keyVaultService: KeyVaultService
  ) {}

  public async trySetDediconSecurityOnDocument(document: Core.Document): Promise<void> {
    const pdfDoc = await document.getPDFDoc();
    if (await pdfDoc.isEncrypted()) {
      const sdfDoc = await pdfDoc.getSDFDoc();
      let trailer = await sdfDoc.getTrailer();
      const dictIter = await trailer.getDictIterator();
      let dediconXmlStr: string | null = null;
      let securityHandlerName: string | null = null;

      for (; await dictIter.hasNext(); await dictIter.next()) {
        if ((await (await dictIter.key()).getName()) === 'Encrypt') {
          const val = await dictIter.value();
          const encryptDictIter = await val.getDictIterator();
          for (; await encryptDictIter.hasNext(); await encryptDictIter.next()) {
            const key = await encryptDictIter.key();
            if ((await key.getName()) === 'DediconData') {
              const value = await encryptDictIter.value();
              dediconXmlStr = await value.getAsPDFText();
            }

            if (await key.getName() === 'Filter') {
              const value = await encryptDictIter.value();
              securityHandlerName = await value.getName();
            }
          }

          break;
        }
      }

      if (dediconXmlStr !== null && securityHandlerName === 'Standard') {
        trailer = await sdfDoc.getTrailer();
        const obj = await trailer.findObj('Encrypt');
        if (obj != null) {
          await obj.putName('Filter', 'Dedicon');
        }
      }
    }
  }

  // TODO: specify proper type here
  public async tryGetDetailsFromDediconFile(file: File): Promise<any> {
    // const pdfNetUtil = this.internalPDFNet;
    const pdfNetUtil = (window as any).Core.PDFNet;

    if (!pdfNetUtil) {
      throw Error('Fatal error. PDFNet not initialized.');
    }

    return new Promise<any>(async (resolve, reject) => {
      try {
        const data = await ((file as any).arrayBuffer() as Promise<ArrayBuffer>);
        const arr = new Uint8Array(data);
        let password = null;
        let isDediconFile = false;
        const optionsObj = {} as any;
        optionsObj.allowMultipleInstances = true;

        const fileWithDetails = await pdfNetUtil.runWithCleanup(async () => {
          try {
            const pdfDoc = await pdfNetUtil.PDFDoc.createFromBuffer(arr);
            if (await pdfDoc.isEncrypted()) {
              const sdfDoc = await pdfDoc.getSDFDoc();
              const trailer = await sdfDoc.getTrailer();
              const dictIter = await trailer.getDictIterator();
              let dediconXmlStr: string | null = null;
              let securityHandlerName: string | null = null;
              for (; await dictIter.hasNext(); await dictIter.next()) {
                if ((await (await dictIter.key()).getName()) === 'Encrypt') {
                  const val = await dictIter.value();
                  const encryptDictIter = await val.getDictIterator();
                  for (; await encryptDictIter.hasNext(); await encryptDictIter.next()) {
                    const key = await encryptDictIter.key();
                    if ((await key.getName()) === 'DediconData') {
                      const value = await encryptDictIter.value();
                      dediconXmlStr = await value.getAsPDFText();
                    }

                    if (await key.getName() === 'Filter') {
                      const value = await encryptDictIter.value();
                      securityHandlerName = await value.getName();
                    }
                  }

                  break;
                }
              }

              if (dediconXmlStr !== null) {
                isDediconFile = true;
                this.ngZone.run(() => {
                  this.toastrService.showToastrByType(ToastrActionEnum.Info, ToastrStringsEnum.OpeningDedicon, true, file.name);
                });
                const dediconDetails = this.parseDediconXML(dediconXmlStr);
                let errorCode: number | null = null;

                if (new Date(dediconDetails.DistributionOrder.ExpirationDate) < new Date()) {
                  errorCode = HuginnErrorCodesEnum.DediconBookIsExpired;
                }

                let dediconData: any = null;
                let isSuccess = false;
                const userInfo = await this.accountService.getAccountInfo();

                if (errorCode === null && userInfo) {
                  const body = {
                    CollectionReferenceId: dediconDetails.DistributionOrder.CollectionReferenceId,
                    DeviceId: userInfo.id.toUpperCase(),
                    DeviceName: getDeviceName().toUpperCase(),
                    DeviceOs: platform.os.toString(),
                    EndUserId: dediconDetails.DistributionOrder.EndUserId,
                    OrderId: dediconDetails.DistributionOrder.OrderId
                  };
                  const requestOptions: any = {};
                  requestOptions.headers = {};
                  requestOptions.headers.Authorization = (await this.getCredentialsFromKeyVault()).secret;
                  dediconData = await this.http.post(
                    dediconDetails.DistributionOrder.ValidationUrl, body, requestOptions
                  ).toPromise()
                    .catch((err) => console.log(err));
                }

                dediconData = dediconData || {};
                isSuccess = dediconData.success || false;

                if (!isSuccess) {
                  if (errorCode === null) {
                    switch (dediconData.errorcode) {
                      case '001':
                        errorCode = HuginnErrorCodesEnum.DediconDocumentIsNotValid;
                        break;
                      case '002':
                        errorCode = HuginnErrorCodesEnum.DediconDocumentIsMachineLimitHasReached;
                        break;
                      case '003':
                        errorCode = HuginnErrorCodesEnum.DediconAccessTokenIsUnknown;
                        break;
                      case '004':
                        errorCode = HuginnErrorCodesEnum.DediconBookCannotBeValidated;
                        break;
                      default:
                        errorCode = HuginnErrorCodesEnum.UnknownDediconServerReply;
                        break;
                    }
                  }

                  // this.modalService.createModalWindow(
                  //   CommonMessageDialogComponent, { messageKey: `HUGINN_ERRORS.${errorCode}` }
                  // );
                  this.toastrService.showApiErrorToastr(errorCode, ApiNamesEnum.Huginn);
                  return {};
                }

                password = dediconData.pwd;

                if (securityHandlerName === 'Dedicon') {
                  this.modalService.createModalWindow(SpinnerComponent);
                  const headers = new HttpHeaders();
                  const authInfo: ILoginResponseModel | null = this.authService.getAuthInfo();

                  if (authInfo && userInfo) {
                    headers.set('Authorization', `Bearer ${authInfo.access_token}`);
                    const formData = new FormData();
                    formData.append('file', file, file.name);
                    const body = {
                      DeviceId: userInfo.id.toUpperCase(),
                      DeviceName: getDeviceName().toUpperCase(),
                      DeviceOs: platform.os.toString()
                    };
                    const options: any = {
                      headers,
                      params: body,
                      responseType: 'arraybuffer',
                      observe: 'response'
                    };
                    try {
                      const response: any = await this.http.post(this.dediconPdfUrl, formData, options)
                        .toPromise();
                      const bytes = response.body ? response.body : response;
                      const convertedFile = new File([bytes], file.name, { type: file.type });
                      file = convertedFile;
                    } catch (error) {
                      // let messageKey = `HUGINN_ERRORS.${error.errorCode}`;
                      // if (!error.errorCode || error.errorCode < 206 && error.errorCode > 212) {
                      //   messageKey = 'COMMONMESSAGEDIALOG.OPEN_KES_FILE_FAIL';
                      // }
                      // this.modalService.createModalWindow(CommonMessageDialogComponent, { messageKey });
                      return {};
                    }
                  }
                }
              }
            }

            this.modalService.closeSpinner();
            return { file, password, isDediconFile };
          } catch (error) {
            console.log(error);
          }

          this.modalService.closeSpinner();
          return {};
        }, environment.pdfTronLicenceKey);

        this.modalService.closeSpinner();
        resolve(fileWithDetails);
      } catch (error) {
        reject(error);
      }
    });
  }

  public closeDediconToastr(key: string): void {
    this.ngZone.run(() => {
      this.toastrService.hideToastr(key);
    });
  }

  // TODO: specify proper type here
  private parseDediconXML(xmlStr: string): any {
    let xmlDoc: any = null;
    if (typeof (window as any).DOMParser !== undefined) {
      xmlDoc = (new (window as any).DOMParser()).parseFromString(xmlStr, 'text/xml');
    } else if (typeof (window as any).ActiveXObject !== undefined && (new (window as any)).ActiveXObject('Microsoft.XMLDOM')) {
      xmlDoc = (new (window as any)).ActiveXObject('Microsoft.XMLDOM');
      xmlDoc.async = 'false';
      xmlDoc.loadXML(xmlStr);
    } else {
      throw new Error('No XML parser found');
    }

    return this.xml2json(xmlDoc);
  }

  // TODO: specify proper type here
  private xml2json(srcDOM: any): any {
    const children = [...srcDOM.children];
    if (!children.length) {
      return srcDOM.innerHTML;
    }

    const jsonResult = {};

    for (const child of children) {
      const childIsArray = children.filter(eachChild => eachChild.nodeName === child.nodeName).length > 1;

      if (childIsArray) {
        if (jsonResult[child.nodeName] === undefined) {
          jsonResult[child.nodeName] = [this.xml2json(child)];
        } else {
          jsonResult[child.nodeName].push(this.xml2json(child));
        }
      } else {
        jsonResult[child.nodeName] = this.xml2json(child);
      }
    }

    return jsonResult;
  }


  public async printDediconPage(instance: WebViewerInstance): Promise<void> {
    const toastrKey = 'dediconPrint';
    this.toastrService.showToastrByType(ToastrActionEnum.Info, ToastrStringsEnum.PrepareDoc, true, toastrKey);
    const doc = await instance.Core.documentViewer.getDocument().getPDFDoc();
    const pageIdx = instance.Core.documentViewer.getCurrentPage() - 1;
    const pageNumber = pageIdx + 1;

    const annotManager = instance.Core.annotationManager;
    const annots = annotManager.getAnnotationsList().filter(e => {
      if (e.PageNumber === pageNumber) {
        return e;
      }
    });
    const xfdfString = await annotManager.exportAnnotations({
      annotList: annots,
      links: false,
      widgets: false,
      fields: false
    });
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xfdfString, 'text/xml');
    const attrname = 'page';
    const x = xmlDoc.getElementsByTagName('annots');

    // TODO: specify proper type here
    for (let i = 0; i < x.length; i++) {
      for (let j = 0; j < x[i].childNodes.length; j++) {
        (x[i].childNodes[j] as any).setAttribute(attrname, 0);
      }
    }
    const parsedXfdfString = new XMLSerializer().serializeToString(xmlDoc.documentElement);
    const currentPage = await doc.getPage(pageNumber);
    const size = await currentPage.getMediaBox();
    const draw = await instance.Core.PDFNet.PDFDraw.create(92);
    await draw.setImageSize(size.x2, size.y2, true);
    await draw.setDrawAnnotations(false);
    const obj = await instance.Core.PDFNet.ObjSet.create();
    const grayHint = await obj.createDict();
    await grayHint.putName('ColorSpace', 'Gray');
    const pngBuffer = await (draw as any).exportStream(currentPage, 'PNG', grayHint);
    await draw.destroy();
    const newDoc = await instance.Core.PDFNet.PDFDoc.create();
    const builder = await instance.Core.PDFNet.ElementBuilder.create();
    const writer = await instance.Core.PDFNet.ElementWriter.create();
    const pageRect = await instance.Core.PDFNet.Rect.init(0, 0, size.x2, size.y2);
    const page = await newDoc.pageCreate(pageRect);
    await writer.beginOnPage(page, instance.Core.PDFNet.ElementWriter.WriteMode.e_overlay);
    const obj1 = await instance.Core.PDFNet.ObjSet.create();
    const obj2 = await obj1.createNumber(0);
    const img = await instance.Core.PDFNet.Image.createFromMemory2(newDoc, pngBuffer, obj2);
    const matrix = await instance.Core.PDFNet.Matrix2D.create((await img.getImageWidth()), 0, 0, (await img.getImageHeight()), 0, 0);
    const element = await builder.createImageFromMatrix(img, matrix);
    const gstate = await element.getGState();
    await gstate.setFillOpacity(0.4);
    writer.writePlacedElement(element);
    writer.end();
    newDoc.pagePushBack(page);
    const docbuf = await newDoc.saveMemoryBuffer(instance.Core.PDFNet.SDFDoc.SaveOptions.e_linearized);
    const div = document.createElement('div');

    // if (webViewerInternalElement) {
    //   webViewerInternalElement.appendChild(div);
    // }
    const webViewerInstance = await WebViewer(webViewerDediconPrintOpts, div);
    const dediconDocViewer = webViewerInstance.Core.documentViewer;
    const dediconAnnotManager = webViewerInstance.Core.annotationManager;
    const annotationsLoaded = () => webViewerInstance.UI.print();

    dediconDocViewer.removeEventListener('annotationsLoaded', annotationsLoaded);
    dediconDocViewer.addEventListener('annotationsLoaded', annotationsLoaded);

    const docLoaded = async () => {
      dediconAnnotManager.importAnnotations(parsedXfdfString)
        .then(() => this.toastrService.hideToastr(toastrKey));

      const annotations = await annotManager.importAnnotations(xfdfString);
      annotManager.drawAnnotationsFromList(annotations);
    };

    dediconDocViewer.removeEventListener('documentLoaded', docLoaded);
    dediconDocViewer.addEventListener('documentLoaded', docLoaded);
    webViewerInstance.UI.loadDocument(new Blob([docbuf]));
  }

  private async getCredentialsFromKeyVault(): Promise<KeyVaultSecretResponse> {
    const response = await this.keyVaultService.getCredentials([KeyVaultKeys.DediconAuthorizationToken]);
    return response[KeyVaultKeys[KeyVaultKeys.DediconAuthorizationToken]];
  }
}
